import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const getAlerImmutableauditSlice = createApi(`GetAlerImmutableauditSlice`,"GET");

const GetAlerImmutableauditSlice = createSlice({
  name: 'GetAlerImmutableauditSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAlerImmutableauditSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAlerImmutableauditSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getAlerImmutableauditSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GetAlerImmutableauditSlice.reducer;